import { useEffect, useState } from 'react';
import { Typography, Box } from '@mui/material';
import { useWhatsappClient } from '../WhatsappClientContext';
import { WHATSAPP_SESSION_DURATION_IN_MILLISECONDS } from '@bandido/shared/constants';
import { useTranslation } from 'react-i18next';

export const SessionCountdown = () => {
  const { lastClientMessage, setIsSessionExpired, isSessionExpired } = useWhatsappClient();
  const [remaining, setRemaining] = useState(0);
  const { t } = useTranslation();

  useEffect(() => {
    if (!lastClientMessage) return;

    const createdTime = new Date(lastClientMessage).getTime();
    const expiresAt = createdTime + WHATSAPP_SESSION_DURATION_IN_MILLISECONDS;

    let interval: NodeJS.Timeout;

    const updateRemaining = () => {
      const now = Date.now();
      const timeLeft = Math.max(0, expiresAt - now);
      setRemaining(timeLeft);

      if (timeLeft <= 0) {
        setIsSessionExpired(true);
        clearInterval(interval);
      } else {
        if (isSessionExpired === true) {
          setIsSessionExpired(false)
        }
      }
    };

    updateRemaining();
    interval = setInterval(updateRemaining, 1000);

    return () => clearInterval(interval);
  }, [lastClientMessage, isSessionExpired]);

  const formatTime = (ms: number) => {
    const totalSeconds = Math.floor(ms / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return `${hours.toString().padStart(2, '0')}:${minutes
      .toString()
      .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  };

  return (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      gap={1}
      width="126px"
    >
      {(isSessionExpired || lastClientMessage === null) ? (
        <Typography variant="caption">
          {t('whatsapp.content.sessionExpired')}
        </Typography>
      ) : (
        <>
          <Typography variant="caption">
            {t('whatsapp.content.timeLeft')}:
          </Typography><Typography variant="caption">
            {formatTime(remaining)}
          </Typography>
        </>
      )}
    </Box>
  );
};
